<script lang="ts" setup>
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import GPromiseButton from './GPromiseButton.vue'
import type { ButtonSize } from './GButton.vue'

withDefaults(defineProps<{ size?: ButtonSize }>(), { size: 'xsmall', })

</script>

<template>
  <GPromiseButton
    danger
    label="Delete"
    :icon="faTrash"
    iconButton
    :size="size"
  />
</template>
